import React, { useEffect, useState } from 'react';

import { Search as SearchIcon } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppAction } from 'src/actions/app.action';
import { BaivietAction } from 'src/actions/baiviet.action';
import * as XLSX from 'xlsx';

import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
  Select,
  MenuItem,
} from '@material-ui/core';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import CreateEditDialog from './CreateEditDialog';

import moment from 'moment';

import { saveAs } from 'file-saver';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Settings, Download, Upload, Cached } from '@material-ui/icons';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const BaivietToolbar = (props) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const [assign, setAssign] = useState(false);
  const { role, info } = useSelector(state => state.profile);
  const { isLoading } = useSelector(state => state.app);
  const [values, setValues] = useState({
    title: "",
    loai_bai: "-99",
    noi_bat: "-99",
  });

  useEffect(() => {
    const today = new Date();

    const payload = {
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
      title: "",
      loai_bai: "-99",
      noi_bat: "-99",
    };
    dispatch(BaivietAction.updateFilter(payload));
  }, []);

  const fileInput = React.useRef();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleImportFile = (e) => {
    e.preventDefault();
    dispatch(AppAction.appLoading(true))
    const files = e.target.files, f = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      let readedData = XLSX.read(data, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      /* Convert array to json*/
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const temp = dataParse.splice(1).map((c) => ({
        phone: c[1],
        type: c[2],
        package: c[3],
        registerAt: c[4],
        expiredAt: c[5],
        packageCycle: c[6],
        state: c[7],
        status: "NORMAL",
        packageCanRegister: c[8]
      }));
      dispatch(BaivietAction.importData(temp));
      dispatch(AppAction.appLoading(false))
      setPreview(true)
      e.target.value = null;
    };
    reader.readAsBinaryString(f)
  }

  const handleClosePreview = () => {
    fileInput.current.value = null;
    setPreview(false)
  }

  const handleCloseAssign = () => {
    fileInput.current.value = null;
    setAssign(false)
  }

  const handleOpenAssign = () => {
    dispatch(BaivietAction.countAssign())
    setAssign(true)
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const onLookup = () => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      title: values.title,
      loai_bai: values.loai_bai,
      noi_bat: values.noi_bat,
    };
    dispatch(BaivietAction.updateFilter(payload));
    dispatch(BaivietAction.list())
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const xuatFile = async () => {
    if (role.priority == 5) return;
    dispatch(AppAction.appLoading(true))
    try {
      const payload = {
        page: 0,
        limit: 9999999999,
        title: values.title,
        loai_bai: values.loai_bai,
        noi_bat: values.noi_bat,
      };
      dispatch(BaivietAction.updateFilter(payload));
      const response = await dispatch(BaivietAction.list());
      console.log(response)

      const data = [
        [
          '#', 
          'Số điện thoại', 
          'Gói cước', 
          'Giá gói cước', 
          'Kênh', 
          'Ngày thành công',
          'Username NV',
          'Tên NV',
          'Lý do',
          'Trạng thái',
          'Người đặt trạng thái',
          'Ngày tạo',
          'Người phê duyệt',
          'Trạng thái duyệt',
        ],
      ];

      if (typeof response !== 'undefined' && response != null && typeof response.data !== 'undefined' && response.data && typeof response.data.values !== 'undefined' && response.data.values && response.data.values.length > 0) {
        var count = 1;
        response.data.values.forEach((element) => {
          let trangThai = "";
          let trangThaiDuyet = "";

          if (element.trang_thai == '0') trangThai = "Chưa đặt";
          else if (element.trang_thai == 'SUCCESS') trangThai = "Thành công";
          else if (element.trang_thai == 'FAILED') trangThai = "Thất bại";

          if (element.trang_thai_duyet == '1') trangThaiDuyet = "Đã duyệt";
          else if (element.trang_thai_duyet == '2') trangThaiDuyet = "Từ chối";
          
          let pushData = [
            count,
            element.so_dien_thoai,
            element.ten_goi_cuoc,
            element.gia_goi_cuoc,
            element.kenh,
            moment(element.ngay_thanh_cong).format('DD-MM-YYYY HH:mm:ss'),
            element.username_nv,
            element.ten_nv,
            element.ly_do,
            trangThai,
            element.nguoi_dat_trang_thai,
            moment(element.created_at).format('DD-MM-YYYY HH:mm:ss'),
            element.nguoi_phe_duyet,
            trangThaiDuyet,
          ];

          data.push(pushData)
          count++;
        })

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Bao-cao-bao-do.xlsx');
      }

      dispatch(AppAction.appLoading(false))
    } catch (error) {
      if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
    }
  }

  const setColor = (value) => {
    if (value == 'co_noi_bat') return '#FF0000';
    else if (value == 'khong_noi_bat') return '#000000';
    else if (value == 'bai_viet') return '#037319';
    else if (value == 'tin_tuc') return '#0000FF';
    else return '#000000';
  };

  return (
    <Box {...props}>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card">
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <PerfectScrollbar>
                <Box sx={{ maxWidth: 500 }}>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="title"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.title}
                    placeholder="Tìm tiêu đề"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <Select
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                    name="loai_bai"
                    value={values.loai_bai || -99}
                    onChange={handleInputChange}
                    variant="outlined"
                    startAdornment={(
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )}
                  >
                    <MenuItem value="-99">Loại bài...</MenuItem>
                    <MenuItem style={{ color: setColor('bai_viet') }} value="bai_viet">Loại: Bài viết</MenuItem>
                    <MenuItem style={{ color: setColor('tin_tuc') }} value="tin_tuc">Loại: Tin tức</MenuItem>
                  </Select>
                  <Select
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                    name="noi_bat"
                    value={values.noi_bat || -99}
                    onChange={handleInputChange}
                    variant="outlined"
                    startAdornment={(
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )}
                  >
                    <MenuItem value="-99">Nổi bật...</MenuItem>
                    <MenuItem style={{ color: setColor('co_noi_bat') }} value="1">Có nổi bật</MenuItem>
                    <MenuItem style={{ color: setColor('khong_noi_bat') }} value="2">Không nổi bật</MenuItem>
                  </Select>
                </Box>
              </PerfectScrollbar>
            </LocalizationProvider>
          </CardContent>
        </Card>
        <Card>
          <div className='functional-btn-container' style={{width: '250px', margin: 'auto'}}>
            <Button
              color="primary"
              variant="contained"
              onClick={handleClickOpen}
              style={{ height: '20px', padding: 0, marginTop: 0, width: "150px", minWidth: '20px', marginLeft: '0', backgroundColor: 'orange', fontWeight: 'normal' }}
              >
              Tạo bản ghi
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={onLookup}
              style={{ background: !isLoading ? 'transparent' : 'url(/static/images/loading.gif) no-repeat center center / contain', height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              {!isLoading ? <Cached style={{ color: "#3498db" }} /> : ''}
            </Button>
          </div>
        </Card>
      </Box>
      <CreateEditDialog open={open} handleClose={handleClose} type={"CREATE"} />
    </Box>
  )
};

export default BaivietToolbar;
